<template>
    <div id="app">
        <div class="app_container role_management">
            <header-bar></header-bar>
            <div class="app_content cl">
                <div class="l content_left">
                    <left-menu :active="active"></left-menu>
                </div>
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import headerBar from '../layout/header/Index'
    import leftMenu from '../layout/menu/Index'
    export default {
        data: function() {
            return {
                active: ''
            }
        },
        components: {
            headerBar,
            leftMenu
        },
        created: function() {
            this.active = localStorage.getItem('menuActive')
            Vue.http.headers.common['token'] = localStorage.getItem('userToken')
        }
    }
</script>


// WEBPACK FOOTER //
// Index.vue?4048cd12